import {
  getCriticality,
  getDateTime,
  getPrismPriorityRank,
  isFullPrismRecord,
  parseDateOnly,
} from "./prismSubscriptionUtils";

export const isDateInRange = (dateValue, dateRange) => {
  if (!dateRange || dateRange.length !== 2 || !dateRange[0] || !dateRange[1]) {
    return true;
  }

  const date = parseDateOnly(dateValue);

  if (!date) return false;

  const startTime = dateRange[0].startOf("day").valueOf();
  const endTime = dateRange[1].endOf("day").valueOf();
  const dateTime = date.getTime();

  return dateTime >= startTime && dateTime <= endTime;
};

export const buildSubscriptionReportRows = ({
  subscriptions = [],
  renewalDateRange = null,
  statusFilter = null,
  criticalityFilter = null,
  details = {},
  canManagePrism = false,
}) =>
  subscriptions
    .filter((subscription) => subscription.is_enabled !== false)
    .map((subscription, index) => {
      const isFullRecord = isFullPrismRecord(subscription, details);

      return {
        originalIndex: index,
        key: subscription.id,
        ...subscription,
        criticality: isFullRecord
          ? getCriticality(
              subscription.contract_renewal_date,
              subscription.subscription_type,
              subscription.contract_status,
            )
          : null,
        isFullRecord,
      };
    })
    .filter((subscription) => {
      const statusMatches = canManagePrism && statusFilter
        ? subscription.isFullRecord &&
          subscription.contract_status === statusFilter
        : true;
      const criticalityMatches = canManagePrism && criticalityFilter
        ? subscription.isFullRecord &&
          subscription.criticality === criticalityFilter
        : true;

      return (
        statusMatches &&
        criticalityMatches &&
        isDateInRange(subscription.contract_renewal_date, renewalDateRange)
      );
    })
    .sort((a, b) => {
      const criticalityRankA = getPrismPriorityRank(a);
      const criticalityRankB = getPrismPriorityRank(b);

      if (criticalityRankA !== criticalityRankB) {
        return criticalityRankA - criticalityRankB;
      }

      const renewalDateA = getDateTime(a.contract_renewal_date);
      const renewalDateB = getDateTime(b.contract_renewal_date);

      if (renewalDateA !== renewalDateB) {
        return renewalDateA - renewalDateB;
      }

      const nameCompare = String(a.subscription_name || "").localeCompare(
        String(b.subscription_name || ""),
      );

      if (nameCompare !== 0) {
        return nameCompare;
      }

      return a.originalIndex - b.originalIndex;
    });
